// import { HttpInterceptorFn } from '@angular/common/http';
// import { inject } from '@angular/core';
// import { AuthService } from './auth.service';
// import { environment } from '../../environments/environment';

// export const authInterceptor: HttpInterceptorFn = (req, next) => {
//   if (!req.url.startsWith(environment.apiBase + '/api/admin/')) {
//     return next(req);
//   }
//   const auth = inject(AuthService);
//   const token = auth.getToken();
//   if (!token) return next(req);
//   return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
// };

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // Only attach tokens to your API
  if (!req.url.startsWith(environment.apiBase)) {
    return next(req);
  }

  const oauth = inject(OAuthService);
  const token = oauth.getAccessToken();

  if (!token) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    })
  );
};